import { useCallback } from 'react';
import useAppSelector from './useAppSelector';

interface UseAppPermissionProps {
    allow: (code: string) => boolean;
}
const useAppPermission = (): UseAppPermissionProps => {
    const permissions = useAppSelector(state => state.auth.permissions);
    const allow = useCallback((code: string): boolean => {
        return permissions.findIndex(p => p.code === code) >= 0;
    }, [permissions])
    return {
        allow
    }
}

export default useAppPermission;